import React from 'react'
import { Box, IconButton, SvgIcon } from '@material-ui/core'
import { Form, Formik } from 'formik'
import { TextField } from '~/components/fields'
import { ClearAutoCompleteSvg, SearchSvg } from '~/components/icons'
import { authStore, routerStore } from '~/stores'
import { PATHS } from '~/common/constants'
import { globalSearchStore } from '~/features/global-search/global-search.store'
import { wrapperStyle } from './global-search.style'

export const GlobalSearch = () => {
	const isGlobalSearchPage = routerStore.basePath === PATHS.care.global_search

	const handleCancel = async (resetForm) => {
		await resetForm()
		await globalSearchStore.reset()
		authStore.id ? routerStore.goPage(PATHS.care.home) : routerStore.goPage(PATHS.care.search)
	}

	return (
		<Box
			css={wrapperStyle}
			className={isGlobalSearchPage ? 'fullWidthWrapper' : authStore.id ? 'normalWrapper' : 'normalWrapper search-input-anonymous'}
			mr={authStore.id ? '' : '10px'}
		>
			<Formik
				initialValues={{
					keyword: '',
				}}
				onSubmit={async (values) => {
					await globalSearchStore.setKeyword(values.keyword)
					if (!isGlobalSearchPage) {
						routerStore.goPage(PATHS.care.global_search)
					}
				}}
			>
				{({ values, setFieldValue, handleSubmit, resetForm }) => (
					<Form className="form-global-search">
						<TextField
							className={authStore.id ? '' : 'search-input-anonymous'}
							name="keyword"
							placeholder={isGlobalSearchPage ? 'Search for jobs by keyword' : 'Search for jobs'}
							fullWidth
							value={values.keyword}
							onChange={(e) => setFieldValue('keyword', e.target.value)}
							onKeyPress={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault()
									handleSubmit()
								}
							}}
							InputProps={{
								endAdornment: (
									<>
										{values.keyword && (
											<SvgIcon
												style={{
													cursor: 'pointer',
													fontSize: 27,
													marginTop: 12,
													marginRight: -10,
												}}
												onClick={() => setFieldValue('keyword', '')}
												width={24}
												height={24}
												viewBox="0 0 24 24"
												component={ClearAutoCompleteSvg}
											/>
										)}
										<IconButton type="submit" size="small">
											<SearchSvg />
										</IconButton>
									</>
								),
							}}
						/>

						{isGlobalSearchPage && (
							<Box marginLeft="1rem">
								<Box
									onClick={() => handleCancel(resetForm)}
									style={{
										color: 'red',
										fontSize: '14px',
										cursor: 'pointer',
										fontWeight: '800',
									}}
								>
									Cancel
								</Box>
							</Box>
						)}
					</Form>
				)}
			</Formik>
		</Box>
	)
}
